export const MWTimings = {
  MultiValueDisplayDelay: 1100,
  TrafficLightSpinningStatusVisibility: 8000,
  MegaMultiplierVisibilityOnStartDealing: 2_500,
  BetsBlosedTooltipVisibility: 1000,
  multiplierAnimationDuration: 3_000,
};
